export default __webpack_public_path__ + "static/media/glasses.bdc8a84e.svg";